import type { ScreenPlacement } from './LeadsPipelineTimeline'

/** Map EZOS template keys to timeline Screening placement. */
export function screenPlacementFromTemplateKey(
    templateKey: string | null | undefined,
): ScreenPlacement {
    switch (templateKey) {
        case 'qualify_first':
            return 'before_signing'
        case 'sign_fast':
            return 'after_signing'
        default:
            // Retired templates / scratch without stored placement.
            return 'before_signing'
    }
}

export function screenPlacementLabel(placement: ScreenPlacement): string {
    return placement === 'before_signing'
        ? 'Screen before signing'
        : 'Screen after signing'
}
